import classNames from 'classnames';
import { mapConditionToLabel } from '../../utils/classifiedUtil';
import PickupBox from '../classified/PickupBox';

import './ClassifiedMetadataBox.less';

const ClassifiedMetadataBox = ({ classified, className = '' }) => <div
  className={classNames('classifiedmetadata', className)}
>
  <PickupBox classified={classified}/>
  <strong className="classifiedmetadata__price">{classified.price},-</strong>

  <strong className="condition">{mapConditionToLabel(classified.condition)}</strong>
</div>;

export default ClassifiedMetadataBox;
